/**
 * @description Footer component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/Footer
 */

import React from 'react';

/**
 * @description The Footer component.
 * @class
 * @extends {React.PureComponent}
 */
class Footer extends React.PureComponent {
    
    /**
     * @inheritdoc
     */
    render() {
        return (
            <footer className="Footer">
                <div className="Footer-logo">
                    <span>&copy; IBI Group {new Date().getFullYear()}</span>
                </div>
                <nav className="Footer-links">
                    <a href={process.env.HOST_SITE_URL}>TII Home</a>
                </nav>
            </footer>
        );
    }
}

export default Footer;
